import { axiosClient } from "../axios";

const baseUrl = "/api/docs/dsr-questionnaire-attachment-documents";

export function get(enterpriseId) {
  return axiosClient.get(`${baseUrl}/${enterpriseId}`);
}

export function save(data) {
  return axiosClient.post(`${baseUrl}/save`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function remove(id) {
  return axiosClient.delete(`${baseUrl}/${id}`);
}

export function download(id) {
  const config = {
    responseType: "blob",
  };
  return axiosClient.get(`${baseUrl}/${id}/download`, config);
}
